import _toConsumableArray from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { computeStrides, sizeFromShape } from '../util';
/**
 * Check whether updates.shape = indices.shape[:batchDim] +
 * shape[sliceDim:]
 *
 * @param x The input tensor.
 */

export function validateUpdateShape(shape, indices, updates) {
  var sliceDim = indices.rank > 1 ? indices.shape[indices.rank - 1] : 1;
  var batchDim = indices.rank > 1 ? indices.rank - 1 : 1;
  var shapeError = 'Must have updates.shape = indices.shape[:batchDim] + ' + "shape[sliceDim:], got updates.shape: ".concat(updates.shape) + ", indices.shape: ".concat(indices.shape, ", shape: ").concat(shape) + ", sliceDim: ".concat(sliceDim, ", and batchDim: ").concat(batchDim, ".");

  if (updates.rank < batchDim) {
    throw new Error(shapeError + " update.rank < ".concat(batchDim, ". "));
  }

  if (shape.length < sliceDim + (updates.rank - batchDim)) {
    throw new Error(shapeError + " Output shape length < ".concat(sliceDim + (updates.rank - batchDim)));
  }

  if (updates.rank !== batchDim + shape.length - sliceDim) {
    throw new Error(shapeError + " update.rank != ".concat(batchDim + shape.length - sliceDim));
  }

  for (var d = 0; d < batchDim; ++d) {
    if (updates.shape[d] !== indices.shape[d]) {
      throw new Error(shapeError + " updates.shape[".concat(d, "] (").concat(updates.shape[d], ") != indices.shape[").concat(d, "] (").concat(indices.shape[d], ")."));
    }
  }

  for (var _d = 0; _d < updates.rank - batchDim; ++_d) {
    if (updates.shape[_d + batchDim] !== shape[_d + sliceDim]) {
      throw new Error(shapeError + " updates.shape[".concat(_d + batchDim, "] (").concat(updates.shape[_d + batchDim], ") != shape[").concat(_d + batchDim, "] (").concat(shape[_d + batchDim], ")"));
    }
  }
}
/**
 * Validate scatter nd inputs.
 *
 * @param update The tensor contains the update values.
 * @param indices The tensor contains the indices for the update values.
 * @param shape The shape of the output tensor.
 */

export function validateInput(updates, indices, shape) {
  if (indices.rank < 1) {
    throw new Error('tf.scatterND() expects the indices to be rank 1 or higher,' + " but the rank was ".concat(indices.rank, "."));
  }

  if (updates.rank < 1) {
    throw new Error('tf.scatterND() expects the updates to be rank 1 or higher,' + " but the rank was ".concat(updates.rank, "."));
  }

  if (indices.dtype !== 'int32') {
    throw new Error("The dtype of 'indices' should be int32, but got dtype: ".concat(indices.dtype));
  }

  if (shape.length < 1) {
    throw new Error("Output rank must be greater or equal to 1, but got shape: ".concat(shape));
  }

  if (shape.length === 0) {
    if (indices.size === 0) {
      throw new Error("Indices specified for empty output. indices shape: ".concat(indices.shape));
    }

    if (updates.size === 0) {
      throw new Error("Updates specified for empty output. updates shape: ".concat(updates.shape));
    }
  }

  validateUpdateShape(shape, indices, updates);
}
/**
 * Calculate the shape information for the output.
 *
 * @param update The tensor contains the update values.
 * @param indices The tensor contains the indices for the update values.
 * @param shape The shape of the output tensor.
 *
 * @returns ScatterShapeInfo
 */

export function calculateShapes(updates, indices, shape) {
  // Calculate the number of dimensions in indices
  var indicesRank = indices.shape.length;
  var sliceRank = indicesRank > 1 ? indices.shape[indicesRank - 1] : 1; // Calculate the number of elements that make up each slice of our updated
  // tensor. This allows us to work with flattened tensors and copy over whole
  // slices at a time.

  var totalNd = shape.length;
  var sliceSize = 1;

  for (var i = sliceRank; i < totalNd; ++i) {
    sliceSize *= shape[i];
  }

  var safeSliceDim = sliceRank < 1 ? 1 : sliceRank;
  var numUpdates = sizeFromShape(indices.shape) / safeSliceDim;
  var strides = [].concat(_toConsumableArray(computeStrides(shape.slice(0, sliceRank))), [1]);
  var outputSize = sizeFromShape(shape);
  return {
    sliceRank: sliceRank,
    numUpdates: numUpdates,
    sliceSize: sliceSize,
    strides: strides,
    outputSize: outputSize
  };
}